import script from "./AddAdministratorsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAdministratorsStep.vue?vue&type=script&setup=true&lang=js"

import "./AddAdministratorsStep.vue?vue&type=style&index=0&id=92ec214e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92ec214e"]])

export default __exports__